var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("h3", [_vm._v("API 简述")]),
      _vm._v(" "),
      _c("p", [
        _vm._v("1.所有的图表都是由 "),
        _c("code", { pre: true }, [_vm._v("点")]),
        _vm._v("、"),
        _c("code", { pre: true }, [_vm._v("线")]),
        _vm._v("、"),
        _c("code", { pre: true }, [_vm._v("面")]),
        _vm._v("、"),
        _c("code", { pre: true }, [_vm._v("文字")]),
        _vm._v(" 构成，其中，Qcharts 中的"),
        _c("code", { pre: true }, [_vm._v("点")]),
        _vm._v("都是由"),
        _c("code", { pre: true }, [_vm._v("面")]),
        _vm._v("来绘制。即 Qcharts 中只有三种类型图形 "),
        _c("b", [
          _c("code", { pre: true }, [_vm._v("线")]),
          _vm._v("、"),
          _c("code", { pre: true }, [_vm._v("面")]),
          _vm._v("、"),
          _c("code", { pre: true }, [_vm._v("文字")])
        ]),
        _vm._v("。")
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("2.Qcharts 中所有的 Visual 和 Plugin，都包含属性"),
        _c("code", { pre: true }, [_vm._v("attr")]),
        _vm._v("和样式"),
        _c("code", { pre: true }, [_vm._v("style")]),
        _vm._v("：")
      ]),
      _vm._v(" "),
      _c("pre", { pre: true }, [
        _c(
          "code",
          { pre: true, attrs: { "v-pre": "", class: "language-javascript" } },
          [
            _c("span", { pre: true, attrs: { class: "hljs-keyword" } }, [
              _vm._v("let")
            ]),
            _vm._v(" line = "),
            _c("span", { pre: true, attrs: { class: "hljs-keyword" } }, [
              _vm._v("new")
            ]),
            _vm._v(" Line({ "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("smooth")
            ]),
            _vm._v(": "),
            _c("span", { pre: true, attrs: { class: "hljs-literal" } }, [
              _vm._v("true")
            ]),
            _vm._v(" })\n")
          ]
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("如上代码：在初始化折线图的时候，"),
        _c("code", { pre: true }, [_vm._v("{smooth:true}")]),
        _vm._v(" 就是属性 "),
        _c("code", { pre: true }, [_vm._v("attr")]),
        _vm._v("。")
      ]),
      _vm._v(" "),
      _c("h5", [_vm._v("通用属性")]),
      _vm._v(" "),
      _c("p", [_vm._v("Qcharts 中，Visual 与 Plugin 有一些通用属性 attr")]),
      _vm._v(" "),
      _c("table", [
        _c("thead", [
          _c("tr", [
            _c("th", [_vm._v("名称")]),
            _vm._v(" "),
            _c("th", [_vm._v("描述")]),
            _vm._v(" "),
            _c("th", [_vm._v("值")])
          ])
        ]),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _c("td", [_vm._v("clientRect")]),
            _vm._v(" "),
            _c("td", [_vm._v("位置信息")]),
            _vm._v(" "),
            _c("td", [_vm._v("可以设置 top,bottom,left,right,widh,height")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("animation")]),
            _vm._v(" "),
            _c("td", [_vm._v("动画属性")]),
            _vm._v(" "),
            _c("td", [_vm._v("可以设置 duration,easing 等")])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("除了属性以外，visual 和 plugin 还有"),
        _c("code", { pre: true }, [_vm._v("style")])
      ]),
      _vm._v(" "),
      _c("pre", { pre: true }, [
        _c(
          "code",
          { pre: true, attrs: { "v-pre": "", class: "language-javascript" } },
          [
            _c("span", { pre: true, attrs: { class: "hljs-comment" } }, [
              _vm._v(
                "//point是一个比较特殊的样式，它除了面的基本属性外，它还有pointType属性，point是由Point插件来完成渲染的,详情查看 Plugin → Point"
              )
            ]),
            _vm._v("\nline.style("),
            _c("span", { pre: true, attrs: { class: "hljs-string" } }, [
              _vm._v("'point'")
            ]),
            _vm._v(", { "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("pointType")
            ]),
            _vm._v(": "),
            _c("span", { pre: true, attrs: { class: "hljs-string" } }, [
              _vm._v("'star'")
            ]),
            _vm._v(", "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("angles")
            ]),
            _vm._v(": "),
            _c("span", { pre: true, attrs: { class: "hljs-number" } }, [
              _vm._v("5")
            ]),
            _vm._v(", "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("innerRadius")
            ]),
            _vm._v(": "),
            _c("span", { pre: true, attrs: { class: "hljs-number" } }, [
              _vm._v("5")
            ]),
            _vm._v(", "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("outerRadius")
            ]),
            _vm._v(": "),
            _c("span", { pre: true, attrs: { class: "hljs-number" } }, [
              _vm._v("10")
            ]),
            _vm._v(" })\n")
          ]
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("如上代码：上面的代码将折线图的 point 类型设置为"),
        _c("code", { pre: true }, [_vm._v("star")]),
        _vm._v("，并设置了内外半径来控制大小。")
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("对于有哪些属性"),
        _c("code", { pre: true }, [_vm._v("attr")]),
        _vm._v("设置，请具体参考具体的 api 文档说明，对于样式"),
        _c("code", { pre: true }, [_vm._v("style")]),
        _vm._v("的设置，"),
        _c("code", { pre: true }, [_vm._v("线")]),
        _vm._v("、"),
        _c("code", { pre: true }, [_vm._v("面")]),
        _vm._v("、"),
        _c("code", { pre: true }, [_vm._v("文字")]),
        _vm._v(" 有一些通用属性，如下：")
      ]),
      _vm._v(" "),
      _c("h5", [_vm._v("线")]),
      _vm._v(" "),
      _c("table", [
        _c("thead", [
          _c("tr", [
            _c("th", [_vm._v("名称")]),
            _vm._v(" "),
            _c("th", [_vm._v("描述")]),
            _vm._v(" "),
            _c("th", [_vm._v("值")])
          ])
        ]),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _c("td", [_vm._v("strokeColor")]),
            _vm._v(" "),
            _c("td", [_vm._v("线颜色")]),
            _vm._v(" "),
            _c("td", [_vm._v("#f00 , rgba(0,0,0,0.5) , transparent")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("lineDash")]),
            _vm._v(" "),
            _c("td", [_vm._v("虚线设置(默认不设置，不设置为实线)")]),
            _vm._v(" "),
            _c("td", [_vm._v("[6,6,6] 实线部分和白线部分的大小依次是 6,6,6")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("lineCap")]),
            _vm._v(" "),
            _c("td", [_vm._v("线条末端绘制样式")]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                "'round' ['butt','round','square'] // 平直边缘、圆形线冒、正方形线冒"
              )
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("lineJoin")]),
            _vm._v(" "),
            _c("td", [_vm._v("两线条交汇处样式")]),
            _vm._v(" "),
            _c("td", [
              _vm._v("'miter' ['bevel','round','miter'] //斜角、圆角、尖角")
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("strokeColor")]),
            _vm._v(" "),
            _c("td", [_vm._v("颜色值（支持 spritejs 中所有的颜色类型）")]),
            _vm._v(" "),
            _c("td", [_vm._v("#f00 , rgba(0,0,0,0.5) , transparent")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("lineWidth")]),
            _vm._v(" "),
            _c("td", [_vm._v("线宽(像素 px)")]),
            _vm._v(" "),
            _c("td", [_vm._v("1 , 2 , 10")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("opacity")]),
            _vm._v(" "),
            _c("td", [_vm._v("透明度(0~1)")]),
            _vm._v(" "),
            _c("td", [_vm._v("1")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("translate")]),
            _vm._v(" "),
            _c("td", [_vm._v("位置变换(像素数组)")]),
            _vm._v(" "),
            _c("td", [_vm._v("[-10，-10]")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("display")]),
            _vm._v(" "),
            _c("td", [_vm._v("展现类型'none'为不渲染")]),
            _vm._v(" "),
            _c("td", [_vm._v("'','none'")])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("h5", [_vm._v("面")]),
      _vm._v(" "),
      _c("table", [
        _c("thead", [
          _c("tr", [
            _c("th", [_vm._v("名称")]),
            _vm._v(" "),
            _c("th", [_vm._v("描述")]),
            _vm._v(" "),
            _c("th", [_vm._v("值")])
          ])
        ]),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _c("td", [_vm._v("strokeColor")]),
            _vm._v(" "),
            _c("td", [_vm._v("边框颜色值")]),
            _vm._v(" "),
            _c("td", [_vm._v("#f00 , rgba(0,0,0,0.5) , transparent")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("fillColor")]),
            _vm._v(" "),
            _c("td", [_vm._v("填充颜色值")]),
            _vm._v(" "),
            _c("td", [_vm._v("#f00 , rgba(0,0,0,0.5) , transparent")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("lineWidth")]),
            _vm._v(" "),
            _c("td", [_vm._v("线宽(像素)")]),
            _vm._v(" "),
            _c("td", [_vm._v("1 , 2 , 10")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("anchor")]),
            _vm._v(" "),
            _c("td", [_vm._v("坐标中心")]),
            _vm._v(" "),
            _c("td", [_vm._v("[0,0]")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("opacity")]),
            _vm._v(" "),
            _c("td", [_vm._v("透明度(0~1)")]),
            _vm._v(" "),
            _c("td", [_vm._v("1")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("translate")]),
            _vm._v(" "),
            _c("td", [_vm._v("位置变换(像素数组)")]),
            _vm._v(" "),
            _c("td", [_vm._v("[-10，-10]")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("display")]),
            _vm._v(" "),
            _c("td", [_vm._v("展现类型'none'为不渲染")]),
            _vm._v(" "),
            _c("td", [_vm._v("'','none'")])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("h5", [_vm._v("文本")]),
      _vm._v(" "),
      _c("table", [
        _c("thead", [
          _c("tr", [
            _c("th", [_vm._v("名称")]),
            _vm._v(" "),
            _c("th", [_vm._v("描述")]),
            _vm._v(" "),
            _c("th", [_vm._v("值")])
          ])
        ]),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _c("td", [_vm._v("bgcolor")]),
            _vm._v(" "),
            _c("td", [_vm._v("文本背景色")]),
            _vm._v(" "),
            _c("td", [_vm._v("#f00 , rgba(0,0,0,0.5) , transparent")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("fillColor")]),
            _vm._v(" "),
            _c("td", [_vm._v("文本颜色")]),
            _vm._v(" "),
            _c("td", [_vm._v("#f00 , rgba(0,0,0,0.5) , transparent")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("fontSize")]),
            _vm._v(" "),
            _c("td", [_vm._v("文本大小(px)")]),
            _vm._v(" "),
            _c("td", [_vm._v("12")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("fontFamily")]),
            _vm._v(" "),
            _c("td", [_vm._v("字体")]),
            _vm._v(" "),
            _c("td", [_vm._v("'Arial'")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("fontWeight")]),
            _vm._v(" "),
            _c("td", [_vm._v("文本加粗")]),
            _vm._v(" "),
            _c("td", [_vm._v("'bold',800,300")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("anchor")]),
            _vm._v(" "),
            _c("td", [_vm._v("坐标中心")]),
            _vm._v(" "),
            _c("td", [_vm._v("[0,0]")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("padding")]),
            _vm._v(" "),
            _c("td", [_vm._v("文字到包围盒边距(px),同 css[上，右，下，左]")]),
            _vm._v(" "),
            _c("td", [_vm._v("[2,4,5,6]")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("opacity")]),
            _vm._v(" "),
            _c("td", [_vm._v("透明度(0~1)")]),
            _vm._v(" "),
            _c("td", [_vm._v("1")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("translate")]),
            _vm._v(" "),
            _c("td", [_vm._v("位置变换(像素数组)")]),
            _vm._v(" "),
            _c("td", [_vm._v("[-10，-10]")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("display")]),
            _vm._v(" "),
            _c("td", [_vm._v("展现类型'none'为不渲染")]),
            _vm._v(" "),
            _c("td", [_vm._v("'','none'")])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }